import React, { Component } from "react";
import { Button, Image } from "react-bootstrap";
import { get } from "lodash";
import IconTime from "../../assets/icon-time.svg";
import MOMDesc from "../MOM/MOMDesc";
import AddDecision from "./AddDecision.issueList";
import {
  dayAgo,
  dateFormat,
  formatNumber,
  getColor,
  transformProjectCategoryId
} from "../../helper";
import { ISSUE_STATUS, PATHS, STATUS } from "../../constant";
import DisplayByPermission from "../../component/DisplayByPermission";
import { DisplayContent } from "../displayContent";
import { Pragati } from "../prgatiReview";
import { Nip } from "../nipReview";
import { Pli } from "../pliReview";
import {
  MultipleTags,
  OrganizationTemplate,
  ReadMore,
  RedirectUser
} from "../reusableComponent";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Link } from "react-router-dom";
import { getLocalstorage } from "../../helper";
import { getActions } from "../../actions/issuesListAction.actions";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import IssueActions from "../issueList/IssueActions";
import { _getIssueList } from "../../actions/issues.action";
import { getMomDetails } from "../../actions/mom.action";
import { shouldDisplayIssueAction } from "../issueList/helper";
import { PmFoundationStone } from "../pmFoundationStone/pmFoundationStone";
import { CmPragatiYatra } from "../cmPragatiYatra/cmPragatiYatra";
import { CmFoundationStone } from "../cmFoundationStone/cmFoundationStone";
import { PmGatiShakti } from "../pmGatiShakti/pmGatiShakti";
import { March24 } from "../march24";
import { PragatiPipeline } from "../prgatiReview/pragatiPipeline";

const MESSAGES_CONSTANT = {
  "Add Decision": "Add decision taken in meeting or by higher authority",
  "Edit Decision": "Edit decision taken in meeting or by higher authority",
  Actions: "Actions"
};

const ToolTip = ({
  text,
  children,
  id,
  containerClass,
  placement = "bottom"
}) => {
  return (
    <OverlayTrigger
      defaultShow={false}
      placement={placement}
      overlay={
        <Tooltip id={id} className={`issues-actions-tooltip ${containerClass}`}>
          {text || null}
        </Tooltip>
      }
    >
      {children}
    </OverlayTrigger>
  );
};

const DRAFT = "DRAFT";
const REJECTED = "Rejected";
const UNDER_CENTRAL_PMG = "under central pmg";
class IssueSingleList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      addDecision: false,
      editDecision: false,
      viewMoreStatus: false,
      project: {},
      issueAction: false,
      showOtherPPList: false
    };
  }

  onToggleModal = () => {
    this.setState(prevState => ({
      displayPopUp: !prevState["displayPopUp"],
      viewMoreStatus: false
    }));
  };

  toggleOtherPPList = () => {
    this.setState({
      showOtherPPList: !this.state.showOtherPPList
    });
  };

  handleViewMore = () => {
    this.onToggleModal();
    this.setState({
      viewMoreStatus: true
    });
  };

  redirectToAgenda = e => {
    let { changeAgendaDetail } = this.props;
    let agendaId = e.target.innerHTML && e.target.innerHTML.replace("#", "");
    this.onToggleModal();
    changeAgendaDetail(agendaId);
  };

  onActionClick = () => {
    let { getActions, issues } = this.props;
    this.setState(
      {
        issueAction: !this.state.issueAction
      },
      async () => {
        if (this.state.issueAction) {
          const response =
            get(issues, "id") &&
            (await getActions(undefined, get(issues, "id")));
          if (response) {
            const { data, status } = response;
            this.setState({
              actionsData: data,
              isActionLoading: (status && STATUS.SUCCESS) || STATUS.ERROR
            });
          }
        }
      }
    );
  };

  callApiOnSuccess = () => {
    const {
      props: {
        _getIssueList,
        getMomDetails,
        agendaData,
        issueListReducer: { selectedFilters }
      }
    } = this;
    _getIssueList({
      ...selectedFilters
    });
    getMomDetails(undefined, { momId: get(agendaData, "id") });
    this.setState({
      issueAction: !this.state.issueAction
    });
  };

  componentDidMount() {
    const { issues } = this.props;
    //project object used to syn keys on add decision component
    let project = {
      totalCost: issues.totalCost,
      displayId: issues.displayId,
      name: issues.projectName,
      sponsoredBy: issues.sponsoringMinistry,
      pendingIssue: issues.pendingIssue,
      organizationName: issues.organizationName,
      projectStatusWithRespectToIssueStatus:
        issues.projectStatusWithRespectToIssueStatus,
      projectCompletionDTO: issues.projectCompletionDTO,
      projectPPList: issues.projectPPList,
      openIssuesCount: issues.openIssuesCount,
      resolvedIssuesCount: issues.resolvedIssuesCount
    };
    this.setState({
      project
    });
  }
  render() {
    const { issues, agendaData, handleUpdateStatus, permission } = this.props;
    const {
      displayPopUp,
      viewMoreStatus,
      project,
      actionsData,
      isActionLoading,
      issueAction,
      showOtherPPList
    } = this.state;
    const { groupCategory } = getLocalstorage("user");
    const showMeetingData = get(issues, "meetingDecisionDTOS", []).find(
      value => {
        return agendaData.id === value.meetingId;
      }
    );
    let displayActions = shouldDisplayIssueAction(actionsData);
    console.log("displayActionsOld", get(issues, "displayActions"));

    let pendingWithSMAndPMG =
      !(
        get(issues, "status") == ISSUE_STATUS["Pending with PMG"] ||
        get(issues, "status") == ISSUE_STATUS["Pending with SM"]
      ) || get(showMeetingData, "decisionStatus") === "DRAFT";

    const createdBy =
      issues.projectPPList && issues.projectPPList.length
        ? issues.projectPPList[0]
        : null;
    const projectPPList =
      issues.projectPPList && issues.projectPPList.length
        ? issues.projectPPList
        : [];
    const projectCost = formatNumber(
      get(project, "revisedCost", 0) || get(issues, "totalCost", "0")
    );
    const userInfo = getLocalstorage("user");
    const isUserStatePMG = get(userInfo, "groupCategory") === "STATE_PMG";
    const centralProject =
      get(project, "sponsoringMinistry", "NA") == "CENTRAL";
    return (
      <React.Fragment>
        <DisplayByPermission display={displayPopUp}>
          <AddDecision
            show={displayPopUp}
            redirectToAgenda={this.redirectToAgenda}
            handleClose={this.onToggleModal}
            issues={issues}
            project={project}
            meetingData={showMeetingData}
            agendaData={agendaData}
            viewMoreStatus={viewMoreStatus}
            handleUpdateStatus={handleUpdateStatus}
            title={
              !showMeetingData ||
              get(showMeetingData, "decisionStatus") === DRAFT
                ? "Add"
                : "Edit"
            }
          />
        </DisplayByPermission>
        <div className="select-issue-wrapper">
          <div className="select-issue-headers agenda-decision-issue">
            <div className="issue-header-info">
              <div className="select-issue-number">
                Project
                <b>
                  <Link
                    to={{
                      pathname: PATHS.PROJECT_DETAILS,
                      search: `?projectId=${get(issues, "projectId")}`,
                      state: {
                        projectId: get(issues, "projectId")
                      }
                    }}
                  >
                    #{get(issues, "displayId", null)}
                  </Link>
                </b>
              </div>
              <div id="agenda-organisation">
                {projectPPList &&
                  projectPPList.map(item => {
                    if (item.organizationGroup) {
                      return (
                        <OrganizationTemplate
                          title={item.organizationGroup}
                          classes="organisation-name"
                        />
                      );
                    }
                  })}
              </div>
              <div id="agenda-detail-issue-list">
                <MultipleTags
                  containerClass="select-issue-single-stages"
                  options={[
                    {
                      title: get(
                        issues,
                        "projectStatusWithRespectToIssueStatus"
                      ),
                      classes: getColor(
                        get(issues, "projectStatusWithRespectToIssueStatus")
                      )
                    },
                    {
                      title:
                        get(issues, "projectCompletionDTO.status") !==
                        "NO IMPLEMENTATION"
                          ? get(issues, "projectCompletionDTO.status")
                          : "",
                      classes:
                        get(issues, "projectCompletionDTO.status") !==
                        "NO IMPLEMENTATION"
                          ? getColor(get(issues, "projectCompletionDTO.status"))
                          : ""
                    }
                  ]}
                />
              </div>

              <div className="select-issue-title">
                {get(issues, "projectName", null)}
              </div>

              <div className="select-issue-sponsoring">
                <label>
                  Sponsoring{" "}
                  {transformProjectCategoryId(
                    get(issues, "sponsoringMinistryCategory")
                  )}
                </label>
                <span>{get(issues, "sponsoringMinistry", null)}</span>
              </div>
              <Pragati
                className={"pragati-review"}
                isValidProject={
                  get(issues, "project.pragatiReview") ||
                  get(issues, "pragatiReview")
                }
              />
              <PragatiPipeline
                className={"pragati-review"}
                isValidProject={
                  get(issues, "project.pragatiPipeline") ||
                  get(issues, "pragatiPipeline")
                }
              />
              <Nip
                className={"pragati-review"}
                isValidProject={
                  get(issues, "project.nipReview") || get(issues, "nipReview")
                }
              />
              <PmFoundationStone
                className={"pragati-review"}
                isValidProject={
                  get(issues, "project.pmFoundationStone") ||
                  get(issues, "pmFoundationStone")
                }
              />
              <CmPragatiYatra
                className={"pragati-review"}
                isValidProject={
                  get(issues, "project.cmPragatiYatra") ||
                  get(issues, "cmPragatiYatra")
                }
              />
              <CmFoundationStone
                className={"pragati-review"}
                isValidProject={
                  get(issues, "project.cmFoundationStone") ||
                  get(issues, "cmFoundationStone")
                }
              />
              <PmGatiShakti
                className={"pragati-review"}
                isValidProject={
                  get(issues, "project.pmGatiShakti") ||
                  get(issues, "pmGatiShakti")
                }
              />
              <Pli
                className={"pragati-review"}
                isValidProject={
                  get(issues, "project.pli") || get(issues, "pli")
                }
              />
              <March24
                className={"pragati-review"}
                isValidProject={
                  get(issues, "project.march24") || get(issues, "march24")
                }
              />
              <div className="select-issue-cost">
                <label>Project Cost</label>
                <span>
                  {parseFloat(projectCost) !== 0
                    ? `₹ ${projectCost} Cr.`
                    : "N/A"}
                </span>
              </div>
              {
                <div className="project-created-by">
                  <label>Project Proponent</label>
                  <span className="first-pp-name">
                    <RedirectUser
                      isIssueForwarded={true}
                      title={get(createdBy, "name", null)}
                      id={get(createdBy, "id", null)}
                    />
                  </span>
                  {projectPPList && projectPPList.length > 1 ? (
                    <div
                      className={`dropdown field-sort ${
                        showOtherPPList ? "visible" : ""
                      }`}
                      onClick={this.toggleOtherPPList}
                    >
                      <div
                        className={`dropdown-overlay ${
                          showOtherPPList ? "visible" : ""
                        }`}
                      />
                      <div className="dropdown-selected-value">
                        + {projectPPList.length - 1}
                      </div>
                      <div className="dropdown-option-list hidden-mobile">
                        <div className="dropdown-option-list-heading" />
                        {projectPPList
                          ? projectPPList.map((value, index) => {
                              if (index !== 0) {
                                return (
                                  <RedirectUser
                                    isProjectProponentDetail={true}
                                    title={get(value, "name", null)}
                                    id={get(value, "id", null)}
                                  />
                                );
                              }
                            })
                          : null}
                      </div>
                    </div>
                  ) : null}
                </div>
              }
            </div>
            {get(agendaData, "meetingStatus") !== "CONCLUDED" &&
            get(agendaData, "meetingStatus") !== "CANCELLED" &&
            get(agendaData, "meetingStatus") !== "POSTPONED" &&
            get(issues, "status").toLowerCase() !== UNDER_CENTRAL_PMG &&
            !(
              get(issues, "visibleToCentralPMG") && groupCategory == "STATE_PMG"
            ) &&
            get(issues, "status") !== REJECTED ? (
              <div className="issue-header-action">
                <div className="add-decision-wrapper">
                  {get(issues, "meetingDecisionDTOS", []).length ? (
                    <React.Fragment>
                      {(!(get(showMeetingData, "decisionStatus") === DRAFT) &&
                        get(showMeetingData, "meetingId")) ||
                      (/resolved/i.test(get(issues, "status")) &&
                        showMeetingData) ? (
                        <div className="edit-decision">
                          <div className="decision-checkmark">
                            <span className="checkmark" />
                          </div>
                          <span className="decision-added">Decision Added</span>
                          <ToolTip text={MESSAGES_CONSTANT["Edit Decision"]}>
                            <DisplayByPermission
                              display={!get(permission, "canViewOnlyProject")}
                            >
                              <Button
                                className="btn-orange-invert no-padding"
                                onClick={this.onToggleModal}
                              >
                                EDIT DECISION
                              </Button>
                            </DisplayByPermission>
                          </ToolTip>
                        </div>
                      ) : !/resolved/i.test(get(issues, "status")) &&
                        !/on hold/i.test(get(issues, "status")) ? (
                        <React.Fragment>
                          {get(issues, "displayActions") ? (
                            <div className="agenda-decision-btn-wrapper">
                              <ToolTip text={MESSAGES_CONSTANT["Actions"]}>
                                <Button
                                  className={`btn-orange no-padding add-decision-btn btn-down-arrow ${
                                    issueAction ? `activity-visible` : ""
                                  }`}
                                  onClick={this.onActionClick}
                                  style={{
                                    display:
                                      isUserStatePMG && centralProject
                                        ? "none"
                                        : null
                                  }}
                                >
                                  Actions
                                </Button>
                              </ToolTip>
                            </div>
                          ) : (
                            <DisplayByPermission
                              display={!get(permission, "canViewOnlyProject")}
                            >
                              {pendingWithSMAndPMG ? (
                                <div className="agenda-decision-btn-wrapper">
                                  <ToolTip
                                    text={MESSAGES_CONSTANT["Add Decision"]}
                                  >
                                    <Button
                                      className="btn-orange no-padding add-decision-btn"
                                      onClick={this.onToggleModal}
                                    >
                                      ADD DECISION
                                    </Button>
                                  </ToolTip>
                                </div>
                              ) : null}
                            </DisplayByPermission>
                          )}
                          {(get(showMeetingData, "decisionStatus") ===
                            DRAFT && (
                            <p className="saved-in-draft">
                              Saved in Draft on{" "}
                              <span className="draft-on">
                                {dateFormat(
                                  get(
                                    showMeetingData,
                                    "decisionSubmittedOn",
                                    "NA"
                                  )
                                )}
                              </span>
                            </p>
                          )) ||
                            null}
                        </React.Fragment>
                      ) : null}
                    </React.Fragment>
                  ) : !/on hold/i.test(get(issues, "status")) ? (
                    get(issues, "displayActions") ? (
                      <div className="agenda-decision-btn-wrapper">
                        <ToolTip text={MESSAGES_CONSTANT["Actions"]}>
                          <Button
                            className={`btn-orange no-padding add-decision-btn btn-down-arrow ${
                              issueAction ? `activity-visible` : ""
                            }`}
                            onClick={this.onActionClick}
                            style={{
                              display:
                                isUserStatePMG && centralProject ? "none" : null
                            }}
                          >
                            Actions
                          </Button>
                        </ToolTip>
                      </div>
                    ) : (
                      <DisplayByPermission
                        display={!get(permission, "canViewOnlyProject")}
                      >
                        {pendingWithSMAndPMG ? (
                          <div className="agenda-decision-btn-wrapper">
                            <ToolTip text={MESSAGES_CONSTANT["Add Decision"]}>
                              <Button
                                className="btn-orange no-padding add-decision-btn"
                                onClick={this.onToggleModal}
                              >
                                ADD DECISION
                              </Button>
                            </ToolTip>
                          </div>
                        ) : null}
                      </DisplayByPermission>
                    )
                  ) : null}
                </div>
              </div>
            ) : null}
          </div>
          <div className="select-issue-content">
            <div className="issue-list-top">
              <div className="issue-list-header">
                <span
                  className={`issue-number ${
                    get(issues, "duplicate") ? "duplicate-issue-number" : ""
                  }`}
                >
                  {get(issues, "duplicate") ? "Duplicate Issue" : "Issue"}{" "}
                  <b>
                    <Link
                      to={{
                        pathname: PATHS.ISSUE_DETAIL,
                        search: `?issueId=${get(issues, "id")}&&projectId=${get(
                          issues,
                          "projectId"
                        )}`
                      }}
                    >
                      #{get(issues, "displayId", null)}-
                      {get(issues, "id", null)}
                    </Link>
                  </b>
                </span>
                <h2 className="issue-title">{get(issues, "title", null)}</h2>
              </div>
              <div className="issue-list-status">
                <div className="issue-list-status-inner">
                  <div className="issue-assignee">
                    {get(issues, "status") === ISSUE_STATUS.REJECT ||
                    get(issues, "status") === ISSUE_STATUS.RESOLVED ||
                    get(issues, "status") === ISSUE_STATUS.REJECTED ||
                    get(issues, "status") === ISSUE_STATUS.HOLD ||
                    get(issues, "status") === ISSUE_STATUS.reject ||
                    get(issues, "status") === ISSUE_STATUS.resolved ||
                    get(issues, "status") === ISSUE_STATUS.hold ||
                    get(issues, "status") === ISSUE_STATUS["On Hold"] ? (
                      get(issues, "status") === ISSUE_STATUS.REJECT ||
                      get(issues, "status") === ISSUE_STATUS.reject ||
                      get(issues, "status") === ISSUE_STATUS.REJECTED ? (
                        <>
                          <span className="issue-assignee-title">
                            Rejected by{" "}
                          </span>
                          <b>{get(issues, "issueStatusChangeGroup")}</b>
                        </>
                      ) : get(issues, "status") === ISSUE_STATUS.RESOLVED ||
                        get(issues, "status") === ISSUE_STATUS.resolved ? (
                        <>
                          <span className="issue-assignee-title">
                            Resolved by{" "}
                          </span>
                          <b>{get(issues, "issueStatusChangeGroup")}</b>
                        </>
                      ) : (
                        <>
                          <span className="issue-assignee-title">
                            On Hold by{" "}
                          </span>
                          <b> {get(issues, "issueStatusChangeGroup")}</b>
                        </>
                      )
                    ) : (
                      <>
                        <span className="issue-assignee-title">
                          Assigned to{" "}
                        </span>
                        <b>{get(issues, "assigneeGroup")}</b>
                      </>
                    )}
                  </div>
                  <div className="issue-assign-date">
                    <Image src={IconTime} alt="Time" />
                    <span>
                      {get(issues, "status") === ISSUE_STATUS.REJECT ||
                      get(issues, "status") === ISSUE_STATUS.RESOLVED ||
                      get(issues, "status") === ISSUE_STATUS.HOLD ||
                      get(issues, "status") === ISSUE_STATUS.reject ||
                      get(issues, "status") === ISSUE_STATUS.resolved ||
                      get(issues, "status") === ISSUE_STATUS.REJECTED ||
                      get(issues, "status") === ISSUE_STATUS.hold ||
                      get(issues, "status") === ISSUE_STATUS["On Hold"]
                        ? `on ${dateFormat(
                            get(issues, "issueStatusChangeDate")
                          )}`
                        : get(issues, "status") ===
                            ISSUE_STATUS["Pending with RM/RS"] ||
                          get(issues, "status") ===
                            ISSUE_STATUS["Pending with PMG"] ||
                          get(issues, "status") ===
                            ISSUE_STATUS["Pending with SM"]
                        ? `on ${dayAgo(get(issues, "issueStatusChangeDate")) ||
                            "NA"}`
                        : get(issues, "lastAssigneeDate")
                        ? dayAgo(get(issues, "lastAssigneeDate"))
                        : dayAgo(get(issues, "createdDate"))}
                    </span>
                  </div>
                </div>
                <Button
                  className={`btn-extra-small animated flipInX ${getColor(
                    get(issues, "status", "NA").toLowerCase()
                  )} unClickable`}
                >
                  {get(issues, "status", "NA")}
                </Button>
              </div>
            </div>
            <div className="issue-list-middle">
              <div className="issue-list-desc-wrapper">
                <span className="issue-recipient">
                  <span className="issue-recipient-title">
                    Recipient{" "}
                    {transformProjectCategoryId(
                      get(issues, "recipientGroupCategory")
                    )}{" "}
                    -{" "}
                  </span>
                  {get(issues, "recipientState", "NA")}
                </span>
                {get(issues, "districtName") ? (
                  <span className="issue-recipient">
                    <span className="issue-recipient-title">
                      {get(issues, "recipientLabel")} -{" "}
                    </span>
                    {get(issues, "districtName")}
                  </span>
                ) : null}
                <p className="issue-category to-n-fro">
                  <span className="slide-issue">
                    <span className="issue-category-title">
                      Issue Category -{" "}
                    </span>
                    {get(issues, "category", null)}
                  </span>
                  <span className="clowdy" />
                </p>
                {get(issues, "subCategory") ? (
                  <p className="issue-sub-category to-n-fro">
                    <span className="slide-issue">
                      <span className="issue-category-title">
                        Issue Sub-Category -{" "}
                      </span>
                      {get(issues, "subCategory", null)}
                    </span>
                    <span className="clowdy" />
                  </p>
                ) : null}
                {get(issues, "proposalNoParivesh") ? (
                  <p className="issue-sub-category">
                    <span className="issue-category-title">
                      Proposal No. (PARIVESH) -{" "}
                    </span>
                    {get(issues, "proposalNoParivesh", "NA")}
                  </p>
                ) : null}
                <div className="issue-list-desc">
                  <ReadMore content={get(issues, "description", "NA")} />
                </div>
                {(get(issues, "latestIssueComments") && (
                  <div>
                    <div className="decision-heading decision-heading-margin">
                      <h3>Latest Comment</h3>
                    </div>
                    <DisplayContent
                      classes={"issue-list-desc"}
                      content={get(issues, "latestIssueComments")}
                    />
                  </div>
                )) ||
                  null}

                {(get(issues, "meetingDecisionDTOS", []).length && (
                  <div className="decision-heading">
                    <h3>Last Decision</h3>
                    <span onClick={this.handleViewMore}>
                      View{" "}
                      {showMeetingData
                        ? get(issues, "meetingDecisionDTOS", []).length - 1
                        : get(issues, "meetingDecisionDTOS", []).length}{" "}
                      more decision
                    </span>
                  </div>
                )) ||
                  null}
                {get(showMeetingData, "meetingId") ? (
                  <MOMDesc issues={issues} meeting={showMeetingData} />
                ) : null}
              </div>
            </div>
          </div>
        </div>
        <DisplayByPermission display={issueAction && displayActions}>
          <div className="issue-actions issue-list-action issue-action-single-list">
            <IssueActions
              isLoading={isActionLoading}
              issueDetails={{ ...issues, ...actionsData }}
              callApiOnSuccess={this.callApiOnSuccess}
            />
          </div>
        </DisplayByPermission>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    issueListReducer: state.issueListReducer
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getActions,
      _getIssueList,
      getMomDetails
    },
    dispatch
  );
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(IssueSingleList)
);
